var _path, _path2, _g, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGreyClock = function SvgGreyClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4984 38.9987C8.72085 38.9987 -0.000488281 30.2224 -0.000488281 19.5351C-0.000488281 8.84786 8.72085 0.000793457 19.4984 0.000793457C30.276 0.000793457 38.9974 8.77709 38.9974 19.4643C38.9974 30.1516 30.2051 38.9987 19.4984 38.9987Z",
    fill: "#BDBFC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5624 3.83665C28.1931 3.83665 35.2255 10.8691 35.2255 19.4997C35.2255 28.1304 28.1931 35.1628 19.5624 35.1628C10.9317 35.1628 3.8993 28.1304 3.8993 19.4997C3.8993 10.8691 10.8678 3.83665 19.5624 3.83665ZM19.5624 0.000793457C8.75805 0.000793457 -0.000488281 8.75933 -0.000488281 19.4997C-0.000488281 30.2401 8.75805 38.9987 19.4984 38.9987C30.2388 38.9987 38.9974 30.2401 38.9974 19.4997C38.9974 8.75933 30.3028 0.000793457 19.5624 0.000793457Z",
    fill: "#8B8C8F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5322 0.000793457V39.0163C30.3187 39.0163 38.999 30.2681 38.999 19.5405C38.999 8.74895 30.2549 0.000793457 19.5322 0.000793457Z",
    fill: "#7A7B7E"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2195 20.7938H19.7285V9.92113",
    stroke: "#002C3B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreyClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/greyClock.98417c6a.svg";
export { ForwardRef as ReactComponent };